import { z } from 'zod';
import { FlakePrefixes } from '../../global-items/prefixes';
import { ZodUtility } from '../../utils';
import { AccountTypes, AccountBillingSettingsSchema } from '../billings';
export var AccountSchema = z.object({
    // This ensures that only `acc_` prefixed flake IDs are allowed.
    _id: ZodUtility.createFlakeIdSchema(FlakePrefixes.Account),
    name: z.string(),
    normalizedName: z.string().nullish(),
    legacyId: z.string().nullish(),
    region: z.string(),
    jvAccount: z.string().nullish(),
    billing: AccountBillingSettingsSchema.nullish(),
    defaultLanguage: z.string().nullish(),
    logo: z.string().nullish(),
    colorCode: z.string().nullish(),
    subdomain: z.string().nullish(),
    archived: z.boolean().nullish(),
    /**
     * Indicates whether this account is managed by a person, or not.
     */
    accountType: z.nativeEnum(AccountTypes).nullish(),
    automatedBilling: z.boolean().nullish(),
    ssoEnabled: z.boolean().nullish(),
});
